import { DEFAULT_DATE_FORMAT } from '@aslanpay/portal-common-lib';
import { addMonths, format, startOfMonth, parseISO } from 'date-fns';

const getMonthsBetween = (startDate: Date, endDate: Date) => {
  const result = [];
  let currentDate = startOfMonth(startDate);

  while (currentDate <= endDate) {
    const monthName = format(currentDate, 'MMM');
    const year = currentDate.getFullYear();
    result.push(`${monthName} ${year % 100}`);
    currentDate = addMonths(currentDate, 1);
  }

  return result;
};

const formatDateToDDMMYYYY = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, DEFAULT_DATE_FORMAT);
  } catch (error) {
    // If parsing fails, return the original string
    return dateString;
  }
};

const formatTimeAgo = (isoDate: string): string => {
  const diffMs = Date.now() - parseISO(isoDate).getTime();
  const diffS = Math.floor(diffMs / 1000);
  const diffM = Math.floor(diffS / 60);
  const diffH = Math.floor(diffM / 60);
  const diffD = Math.floor(diffH / 24);
  if (diffD > 0) return `${diffD}d ago`;
  if (diffH > 0) return `${diffH}h ago`;
  if (diffM > 0) return `${diffM}m ago`;
  return `${diffS}s ago`;
};

export default getMonthsBetween;
export { formatDateToDDMMYYYY, formatTimeAgo };
